import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import dividendAbi from '../abi/dividend.json';
import pairAbi from '../abi/PairContract.json';
import tokenAbi from '../abi/token.json';
import { DEFAULT_CHAIN, contract } from "../helper/constant";
import { getMultiCall, getWeb3Contract } from "../helper/contractHelper";
import axios from "axios";


export const useTokenInfoStats = (updater) => {

    const [stats, setStats] = useState({
        decimal: 0,
        totalSuppl: 0,
        getCirculatingSupply: 0,
        eth_price: 0,
        barc_price: 0,
        totalDistributed: 0,
        liquidity: 0,
        totalBuyTax: 0,
        totalSellTax: 0,
        loading : true
    });

    const tokenContract = getWeb3Contract(tokenAbi, contract[DEFAULT_CHAIN].BARC_ADDRESS);
    const tokenLpContract = getWeb3Contract(pairAbi, contract[DEFAULT_CHAIN].BARC_LP_ADDRESS);
    const dividendContarct = getWeb3Contract(dividendAbi, contract[DEFAULT_CHAIN].DIVIDEND_ADDRESS);



    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    tokenContract.methods.decimals(), //0
                    tokenContract.methods.totalSupply(), //1
                    tokenLpContract.methods.getReserves(), //2
                    dividendContarct.methods.totalDistributed(), //3
                    tokenContract.methods.balanceOf(contract[DEFAULT_CHAIN].BARC_LP_ADDRESS), //4
                    dividendContarct.methods.totalReserved(), //5
                    tokenContract.methods.totalBuyTax(), //6
                    tokenContract.methods.totalSellTax(), //7
                ])

                // const response = await axios.get('https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd');
                
                let eth_price =  2100 //parseFloat(response.data.ethereum.usd);
                let barc_price = eth_price * (data[2][1] / data[2][0]);

                
                setStats({
                    decimal: data[0],
                    totalSuppl: data[1] / Math.pow(10, data[0]),
                    eth_price: eth_price,
                    barc_price: barc_price,
                    totalDistributed: (parseFloat(data[3] / Math.pow(10, 18)) - parseFloat(data[5] / Math.pow(10, 18))) * (barc_price),
                    liquidity: parseFloat(data[4] / Math.pow(10, 18)) * 2 * barc_price,
                    totalBuyTax: data[6],
                    totalSellTax: data[7],
                    loading : false
                })

            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater]);

    return stats;
}
